import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { Seo } from "@/components/Seo";
import { useI18n } from "@/i18n/I18nContext";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const { tl } = useI18n();
  return (
    <PublicLayout>
      <Seo title="Página no encontrada — Frenchies Fitness & Pilates" description="Esta página no existe." path="/404" noindex />
      <section className="mx-auto max-w-3xl px-5 py-24 text-center lg:px-8" data-testid="not-found">
        <div className="font-display text-7xl font-black text-primary">404</div>
        <h1 className="mt-4 font-display text-3xl font-bold tracking-tight">{tl({ es: "Página no encontrada", en: "Page not found", fr: "Page introuvable" })}</h1>
        <p className="mt-3 text-muted-foreground">{tl({ es: "El enlace puede estar roto o la página se movió.", en: "The link may be broken or the page has moved.", fr: "Le lien est peut-être cassé ou la page a été déplacée." })}</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Button asChild className="rounded-full"><Link to="/">{tl({ es: "Ir al inicio", en: "Go home", fr: "Accueil" })}</Link></Button>
          <Button asChild variant="outline" className="rounded-full"><Link to="/horarios">{tl({ es: "Ver horarios", en: "See schedule", fr: "Voir les horaires" })}</Link></Button>
        </div>
      </section>
    </PublicLayout>
  );
}
